module.exports = __webpack_public_path__ + "static/media/flag-thailand.c4f2c06e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-thailand.svg
// module id = 1135
// module chunks = 1